function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M31.5 16c0 8.56-6.94 15.5-15.5 15.5C7.44 31.5.5 24.56.5 16 .5 7.44 7.44.5 16 .5 24.56.5 31.5 7.44 31.5 16z",
  fill: "#fff",
  stroke: "#C4CED4"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#qwick-circle-white_svg__pattern0)",
  d: "M12 8h8v17.425h-8z"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, React.createElement("pattern", {
  id: "qwick-circle-white_svg__pattern0",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, React.createElement("use", {
  xlinkHref: "#qwick-circle-white_svg__image0",
  transform: "scale(.0137 .00629)"
})), React.createElement("image", {
  id: "qwick-circle-white_svg__image0",
  width: 73,
  height: 159,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEkAAACfCAYAAAC1FPTuAAAACXBIWXMAAAsSAAALEgHS3X78AAAEr0lEQVR42u3dPXLaQBQH8L933JucINwgpAmdLI8bzbjI5gbKCUJOEHKCkBNEPkGUggkNM0CnKuYEwSdIOIFTaMk4BLA+Vton6f862wMWP96T3n4gzh4eHiAhhrOVD8A3P94lgRdDSJxJQBrOVmMAH/Z+fZsEXkikFGgA4MeRP79NAi9yjaQEvFGnskVLyCQJSKcgXg9nq16nkUypPS+B2IlMCktmWieQsgA4LzklvNREZJMSXmqdR8rzwp2WnHJUav0cpeY8m1QDsmgXfteQwppgm4lkSu1FgYdeDGcr3ZVM0o4e2yikkEjVlJrTklMNKjVn2aQaVGrtR7JQas5Krs5M8oWVbeaoZY7bjLvuCgxFjsUWwCAJvE0rMslMiSwsAgHABYCFWYaqJ5NMjY8tnTPaEPcAoiTwxgBw9ur7UgP4SpeD8TEJvPHZq+/LjeVSaFs8UwR6MgbKXCkYx2OjAER0OBrLJPA2ylzVvtHjv1jvmta/zeRwthoZsAv6pFe1gx23afyiDvdLWwA6CbzF0Y47Cbw7M8b63EGgbwD6+0Anx26mC486Un7vk8CbFBrgmumNCMBli0/OoamgcrMAR7brNT1uAYySwPudaYCbYzQft6BD35rsybxxNfNUiUnJQcN7qjXSeahcO3sLTboNZ6sQwKRhJ/V/ep/KkRrWUx3sfWpBeoQ1AfBOcO8TZjk5V4r0qPy+NKn3qR1JYJuwTALPt/VkNhcCFoKyKLL5ZArtjJ5UJC0IySfS02F1I6oVpJx7susKLS2TQoHnJXFIvkAkayWnLJRaX/DQREvJJA254UtBCgUjuc8k4aUGWNoVp1pcataO8VxQqW2RTg//Ni/suRSkMpNufQA/Lb2Q/+Z9LM9TvSlzMwbluNS2SOd99P7EWBJ4IwBvYGfXS6ljVQ5LbQ3APzUxZt79PoClS6SiCwE9AL9K/N/PAMZ5plXNho5PLkpO1fzObM3BjvLOO5uMe4l002et2VQn0hIF1rz2oHZrf7d1dt+5y61gqRVe8zpxHCHyr/29fGrd31Ym5cmiewBXtoFMVkUmq9ZVX2yKIPVz9D6DMouCGaA2SeANkH0/1cDVADdz71Mh1gjAFSraSVwEaVGm96kQapGhpyp00SjaJx0aMuTufaqKIz1V4dufld0wsTuJx0WuGhVD9c3x9QAsnG6Y6EIoEhCJSEQiEpGIRCQGkYhEJLdxLuVArm+0v/erzXwabyQcm9MB7vWN7iP93K/G4bnqNYDJfBpHnUS6vtEhsk/kLwHo+TR2MlelHAJ9QfaVjks43EyvHJVYkendF9c3etKVTBqj+Ofk3hnk1iNpx4+XjWQu82U/bemzmXw6ekTisIRIRCISg0hEIhKRiEQkIjGIRCQiEYlIRCISg0hEIhKRiEQkIhGJQSQiEYlIRCISkRhEIhKRiEQkIhGJSCQgEpGIRCQiEYlIDCIRiUhEIhKRiMQgEpGIRCQiESlTbIQ8h1wkc0vE+5JPs+hCuUUlHrt1cTtFF0iTEtkUduLEbe4VqZH/22pu59M47gSSgdp9BVmWL4vaAng/n8ZOsggQ8L0l5sacGukN7R7fFG+N9Gt9Itf3wP0DqZCqz/kHvGcAAAAASUVORK5CYII="
}));

function SvgQwickCircleWhite(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default SvgQwickCircleWhite;